<template>
  <a-layout-footer style="textAlign: center">
    Copyright © 2022 Geekchic All rights reserved. Inspired By Vue & Ant Design Vue
  </a-layout-footer>
</template>

<script>
export default {
  name: 'Footer'
};
</script>
